<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;">PROJELER</h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Tanımlar</li>
            <li class="breadcrumb-item active">Projeler</li>
        </ol>
    </div>
    <div class="data-grid">
        <p-table #dt [value]="logoProjects$ | async" [paginator]="true" [rows]="25" [showCurrentPageReport]="true"
            styleClass="p-datatable-sm" [rowHover]="true"
            currentPageReportTemplate="{totalRecords} veriden {first} - {last} gösteriliyor.."
            [globalFilterFields]="['code','name','begdate','enddate']" [responsive]="true"
            [rowsPerPageOptions]="[5,10,25,50]">
            <ng-template pTemplate="caption">
                <div style="text-align: right">
                    <input style="float:right" type="text" pInputText size="50" placeholder="Ara"
                        (input)="applyFilterGlobal($event, 'contains')" style="width:auto">
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="code" [width]="'10%'">Proje Kodu<p-sortIcon field="code"></p-sortIcon>
                    </th>
                    <th pSortableColumn="name" [width]="'40%'">Proje Adı<p-sortIcon field="name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="begdate" [width]="'25%'">Başlangıç Tarihi<p-sortIcon field="begdate">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="enddate" [width]="'25%'">Bitiş Tarihi<p-sortIcon field="enddate"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-projects>
                <tr>
                    <td>{{projects.code}}</td>
                    <td>{{projects.name}}</td>
                    <td>{{projects.begdate | date :"dd-MM-yyyy"}}</td>
                    <td>{{projects.enddate | date :"dd-MM-yyyy"}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>